import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Grid from '@material-ui/core/Grid';

import { API_URL } from '../common/Constants';
import axios from 'axios';

// import TitleText from '../common/TitleText';
import './introduction.css';
const styles = (theme) => ({
  content_bg: {
    backgroundColor: '#fff',
    margin: '0 auto',
    width: '930px',
    padding: '0 80px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 30px',
      width: '100%',
    },
  },

  webVer: {
    paddingBottom: '50px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobVer: {
    paddingBottom: '24px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

class Doowon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      imgData: '',
    };
  }
  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    // const { classes } = this.props;

    return (
      <React.Fragment>
        <Topbar />
        <div className="dw_bg">
          <Grid
            id="index_grid"
            container
            justify="flex-start"
            style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
          >
            <b>제품소개 〉 두원 스탬프투어</b>
          </Grid>
          <div className="bg_inner">
            <img
              src={this.state.imgData.m2_1}
              alt={'img'}
              style={{ width: '100%', paddingTop: '4vh', WebkitTouchCallout: 'none' }}
              onContextMenu={(e) => e.preventDefault()}
            />
            {/* <div className={classes.webVer}>
              <TitleText title="두원 스탬프투어" />
              <Grid container justify="center" alignItems="center">
                <img src="./images/doowon/success.png" alt="" className="mainImg" style={{ width: '100%', marginBottom: '50px' }} />
              </Grid>
              <TitleText title="스탬프투어 통합컨설팅" />
              <Grid container justify="center" alignItems="center" spacing={3} style={{ marginBottom: '50px' }}>
                <Grid item xs={12} sm={6}>
                  <img src="./images/doowon/solution.png" alt="" className="mainImg" style={{ width: '92%' }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <img src="./images/doowon/product.png" alt="" className="mainImg" style={{ width: '100%' }} />
                </Grid>
              </Grid>
              <p
                style={{
                  backgroundColor: '#2a285e',
                  color: '#fff',
                  padding: '18px 0',
                  width: '90%',
                  fontSize: '18px',
                  borderRadius: '10px',
                  textAlign: 'center',
                  margin: '50px auto 20px',
                }}
              >
                <b>대상처별</b> 특별한 <b>스탬프투어 기획 및 통합솔루션</b> 제공
              </p>
              <p
                style={{
                  backgroundColor: '#fafafa',
                  width: '90%',
                  borderRadius: '10px',
                  color: '#2a285e',
                  padding: '18px 0',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  textAlign: 'center',
                  margin: '0 auto',
                }}
              >
                체류형 관광활성화 유도
              </p>
            </div>
            <div className={classes.mobVer}>
              <TitleText title="두원 스탬프투어" />
              <Grid container justify="center" alignItems="center">
                <img src="./images/doowon/success_mobile_0.png" alt="" className="mainImg" style={{ width: '80%', marginBottom: '50px' }} />
              </Grid>
              <Grid container justify="center" alignItems="center">
                <img
                  src="./images/doowon/success_mobile_1@3x.png"
                  alt=""
                  className="mainImg"
                  style={{ width: '100%', marginBottom: '50px' }}
                />
              </Grid>
              <Grid container justify="center" alignItems="center">
                <img
                  src="./images/doowon/success_mobile_2@3x.png"
                  alt=""
                  className="mainImg"
                  style={{ width: '100%', marginBottom: '50px' }}
                />
              </Grid>
              <TitleText title="스탬프투어 통합컨설팅" />
              <Grid container justify="center" alignItems="center">
                <img
                  src="./images/doowon/solution_mobile@3x.png"
                  alt=""
                  className="mainImg"
                  style={{ width: '95%', marginBottom: '50px' }}
                />
              </Grid>
              <Grid container justify="center" alignItems="center">
                <img
                  src="./images/doowon/product_mobile@3x.png"
                  alt=""
                  className="mainImg"
                  style={{ width: '100%', marginBottom: '50px' }}
                />
              </Grid>
              <p
                style={{
                  backgroundColor: '#2a285e',
                  color: '#fff',
                  padding: '18px 0',
                  width: '100%',
                  fontSize: '12px',
                  borderRadius: '10px',
                  textAlign: 'center',
                  margin: '20px auto 10px',
                }}
              >
                <b>대상처별</b> 특별한
                <b>
                  스탬프투어 기획 및<br /> 통합솔루션
                </b>
                제공
              </p>
              <p
                style={{
                  //backgroundColor: '#fff',
                  color: '#2a285e',
                  padding: '18px 0',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  borderRadius: '10px',
                  textAlign: 'center',
                  backgroundColor: '#fafafa',
                }}
              >
                체류형 관광활성화 유도
              </p>
            </div> */}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Doowon));
